import { createContext } from 'react';

import { ChartLayoutRatioContextProps } from '../types/chart-layout.js';

export const ChartLayoutRatioContext =
  createContext<ChartLayoutRatioContextProps>({
    readyForAutoRatio: false,
  } as ChartLayoutRatioContextProps);

ChartLayoutRatioContext['displayName'] = 'ChartLayoutRatioContext';
